/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallExecutionRecord } from './CallExecutionRecord';
import {
    CallExecutionRecordFromJSON,
    CallExecutionRecordFromJSONTyped,
    CallExecutionRecordToJSON,
} from './CallExecutionRecord';

/**
 * 
 * @export
 * @interface FindCallExecutionById200Response
 */
export interface FindCallExecutionById200Response {
    /**
     * 
     * @type {CallExecutionRecord}
     * @memberof FindCallExecutionById200Response
     */
    data?: CallExecutionRecord;
}

/**
 * Check if a given object implements the FindCallExecutionById200Response interface.
 */
export function instanceOfFindCallExecutionById200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindCallExecutionById200ResponseFromJSON(json: any): FindCallExecutionById200Response {
    return FindCallExecutionById200ResponseFromJSONTyped(json, false);
}

export function FindCallExecutionById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCallExecutionById200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CallExecutionRecordFromJSON(json['data']),
    };
}

export function FindCallExecutionById200ResponseToJSON(value?: FindCallExecutionById200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CallExecutionRecordToJSON(value.data),
    };
}

